<script lang="ts" setup>
import { useRoute, RouterView } from 'vue-router';
import { computed, useId } from 'vue';
import { provideUseId } from '@headlessui/vue';
import LayoutNormal from '@/layouts/normal.vue';
import { AssistantFloatChat } from '@/components/assistant';
import { provideAssistantChat } from '@/hooks/assistant-chat';

provideUseId(() => useId() as string);

const route = useRoute();
const {
  isPanelOpen,
  pendingQuestion,
  quickQuestions,
  clearPendingQuestion,
  updateQuestions,
} = provideAssistantChat();

const layout = computed(() => {
  if (route.meta.layout) {
    return route.meta.layout;
  }
  else {
    return LayoutNormal;
  }
});
</script>

<template>
  <img src="@/assets/common/logo-300x300.png" alt="开放原子开源基金会" class="block h-0 w-0">

  <Component :is="layout">
    <RouterView />
  </Component>

  <ClientOnly>
    <AssistantFloatChat
      v-model:open="isPanelOpen"
      :pending-question="pendingQuestion"
      :questions="quickQuestions"
      @pending-question-handled="clearPendingQuestion"
      @questions-updated="updateQuestions"
    />
  </ClientOnly>
</template>

<style lang="scss" scoped>
</style>
